/**
 * Bilingual copy for the Downloads page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  errorFetch: 'Unable to load downloads right now. Please try again later.',
  emptyTitle: 'No downloads available yet',
  emptyBodyPrefix: 'Add files to the ',
  emptyBodyMiddle: ' folder and list them in ',
  emptyBodySuffix: ' to have them appear here.',
  download: 'Download',
  eyebrow: 'Resources',
  title: 'Downloads',
  subtitle: 'Access product brochures, guides, and other helpful files.',
  availableTitle: 'Available files',
  availableDesc: 'Files listed below are ready for download. Add new assets to keep this list current.',
};

export type Copy = typeof en;

export const km: Copy = {
  errorFetch: 'មិនអាចផ្ទុកឯកសារទាញយកបានទេនៅពេលនេះ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។',
  emptyTitle: 'មិនទាន់មានឯកសារសម្រាប់ទាញយកនៅឡើយទេ',
  emptyBodyPrefix: 'សូមបន្ថែមឯកសារទៅក្នុងថត ',
  emptyBodyMiddle: ' រួចចុះបញ្ជីពួកវាក្នុង ',
  emptyBodySuffix: ' ដើម្បីឱ្យវាបង្ហាញនៅទីនេះ។',
  download: 'ទាញយក',
  eyebrow: 'ធនធាន',
  title: 'ឯកសារទាញយក',
  subtitle: 'ខិត្តប័ណ្ណផលិតផល មគ្គុទ្ទេសក៍ និងឯកសារដែលមានប្រយោជន៍ផ្សេងទៀត សម្រាប់អ្នកទាញយក។',
  availableTitle: 'ឯកសារដែលមានរួចហើយ',
  availableDesc: 'ឯកសារខាងក្រោមអាចទាញយកបាន។ យើងបន្ថែមឯកសារថ្មីៗជាប្រចាំ ដើម្បីរក្សាបញ្ជីនេះឱ្យទាន់សម័យ។',
};
